import { Button, Card, Col, Empty, Layout, Row, Typography } from 'antd'
import { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useDocumentTitle from '../lib/useDocumentTitle'
import { BaseLayoutContext } from './BaseLayoutContext'

export default function WelcomeComponent() {
  const { t } = useTranslation()
  useDocumentTitle(t('frontend:welcome.pageTitle'))

  const [, setTopMenu] = useContext(BaseLayoutContext)

  useEffect(() => {
    setTopMenu({})
  }, [setTopMenu])

  return (
    <Layout>
      <Row>
        <Col
          xs={24}
          md={{ span: 18, offset: 3 }}
          lg={{ span: 16, offset: 4 }}
          xl={{ span: 10, offset: 7 }}
        >
          <Card bordered={false}>
            <Empty description="" />
            <center>
              <Typography.Title level={3}>
                {t('frontend:welcome.heading')}
              </Typography.Title>

              <Typography.Paragraph>
                {t('frontend:welcome.intro')}
              </Typography.Paragraph>

              <Typography.Title level={4}>
                {t('frontend:welcome.employeeHeading')}
              </Typography.Title>
              <Typography.Paragraph>
                {t('frontend:welcome.employeeText')}
              </Typography.Paragraph>

              <Typography.Title level={4}>
                {t('frontend:welcome.companyHeading')}
              </Typography.Title>
              <Typography.Paragraph>
                {t('frontend:welcome.companyText')}
              </Typography.Paragraph>
              <Button type="primary">
                <a
                  href="https://calendly.com/anton-zimmer-cleverlohn/kurzer-austausch-zur-lohnbuchhaltung"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('frontend:welcome.bookCall')}
                </a>
              </Button>
            </center>
          </Card>
        </Col>
      </Row>
    </Layout>
  )
}
